import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';
import { map, catchError, concatMap, switchMap } from 'rxjs/operators';

import { AppState } from '..';
import { HomeScreenActionTypes } from '../actions/home-screen.actions';
import { HomeScreenService } from '../../services/home-screen.service';

@Injectable()
export class HomeScreenEffect {
    constructor(
        private _actions$: Actions,
        private _homeScreenService: HomeScreenService,
        private _store: Store<AppState>
    ) { }

    loadHomeScreensEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(HomeScreenActionTypes.LOAD),
        map((action: any) => action.payload),
        switchMap((res) => {
            return this._homeScreenService.getHomeScreens().pipe(
                map(response => {
                    return ({
                        type: HomeScreenActionTypes.LOAD_SUCCESS,
                        payload: {
                            type: res,
                            data: response['screen-list']
                        }
                    });
                })
            );
        }),
        catchError((err, caught) => {
            return of({
                type: HomeScreenActionTypes.LOAD_FAILED,
                payload: err.message
            });
        })
    ));

    deleteHomeScreenEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(HomeScreenActionTypes.DELETE),
        switchMap((action: any) => {
            const layoutId = action.payload;
            return this._homeScreenService.deleteHomeScreenLayoutById(layoutId).pipe(
                map(() => {
                    return {
                        type: HomeScreenActionTypes.DELETE_SUCCESS
                    };
                }),
                catchError(err => {
                    return of({
                        type: HomeScreenActionTypes.DELETE_FAILED
                    });
                }),
            );
        })
    ));
}
